import { render } from "./Auth.vue?vue&type=template&id=00d4e807&scoped=true"
const script = {}

import "./Auth.vue?vue&type=style&index=0&id=00d4e807&scoped=true&lang=css"

import exportComponent from "/Users/giacomo/Developer/tandu/barbera/barberabilance-docs-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d4e807"]])

export default __exports__